import { Toast } from "@prequel/shared-components";

import { useToast } from "@/providers/ToastProvider";

const Alerts = () => {
  const { toasts, dismissToast } = useToast();

  if (!toasts || toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed right-0 bottom-0 z-20 w-1/3 space-y-1 overflow-y-auto p-5">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} dismissHandler={dismissToast} />
      ))}
    </div>
  );
};

export default Alerts;
